import PopConfirm from './PopConfirm';

export default PopConfirm;
